import React, { useState, useEffect, useContext } from "react";
import { Link, NavLink, useParams, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { WebAssetsContext } from "../App";
import { ToastContainer, toast , Zoom } from 'react-toastify';
import {errorToast  } from '../functions/Function';

const Useredit = (props) => {
  const WebAssets = useContext(WebAssetsContext);
  const api = WebAssets.apiURL;
  const navigate = useNavigate();
  const params = useParams();
  const [disabled, setDisabled] = useState(false);
  const [id, setId] = useState(params.id);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [status, setStatus] = useState(0);
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [emailverify, setEmailverify] = useState("0");
  const [is_mobile_verified, setis_mobile_verified] = useState("0");
  const [is_approved, setis_approved] = useState("0");
  const successtoast = (text = '') => {
    toast.success(text);
  };

  const errortoast = (text) => {
    toast.error(text,
      {
        autoClose: 3000,
        transition: Zoom,
        theme: "colored",
        closeOnClick: true,
        pauseOnHover: true,
      }
    );
  };

  const actvieStatus = () => {
    setStatus('1');
  }

  const inactvieStatus = () => {
    setStatus('0');
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(true);
    try {
      let res = await fetch(api + "updateUser", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: id,
          name: name,
          email: email,
          password: password,
          phone: mobileNumber,
          address: address,
          city: city,
          status: status,
          emailverify: emailverify,
          is_mobile_verified: is_mobile_verified,
          is_approved: is_approved,
        }),
      });
      let output = await res.json();
      setDisabled(false);
      if (res.status === 200) {
        if (output.status === 2) {
          getvalidationErr(output.response);
        }
        if (output.status === true) {
          Swal.fire({
            title: 'Success',
            text: 'User updated successfully!',
            icon: 'success'
          }).then((result) => {
            if (result.isConfirmed) {
                navigate("/admin/users");
            }
          });
        }else
        {
          errorToast(output.response, 'bottom-right', 1500, true);
        }
      }
    } catch (err) {
      setDisabled(false);
    }
  };

  const getvalidationErr = (errors) => {
    const errorsConvertInArry = Object.values(errors);
    let collectAllValidationErr = [];
    errorsConvertInArry.forEach((error, index) => {
      collectAllValidationErr.push(<div key={index}>{error}</div>);
    });
    const storeAllValidtionErr = (
      <>
        {collectAllValidationErr}
      </>
    );
    errortoast(storeAllValidtionErr);
  }



  const getuserdata = async () => {
    const res = await fetch(api + "getUser", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: id }),
    });
    let resJson = await res.json();
    return resJson;
  }

  const getUser = async () => {
    try {
      const resJson = getuserdata();
      resJson.then(function (output) {
        if (output.status === true) {
          setName(output.response.name);
          setEmail(output.response.email);
          setMobileNumber(output.response.phone);
          setStatus(output.response.status);
          setAddress(output.response.address);
          
          if(output.response.is_email_verify == '1')
              {
                setEmailverify('1');
              }else
              {
                setEmailverify('0');
              }
              if(output.response.is_mobile_verified == '1')
              {
                setis_mobile_verified('1');
              }else
              {
                setis_mobile_verified('0');
              }

              if(output.response.	is_approved == '1')
              {
                setis_approved('1');
              }else
              {
                setis_approved('0');
              }
            
          setCity(output.response.city);
         
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getUser();
  }, [])
  return (
    <>
     
      <ToastContainer />
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h4>Edit Customer Information</h4>
              <div className="card-header-form">
                <button onClick={() => navigate("/admin/users")} className="btn btn-icon icon-left btn-primary"><i className="fas fa-arrow-right"></i> Back</button>
              </div>
            </div>
            <div className="card-body p-4">
              {name ? 
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Name<small className="text-danger">*</small></label>
                      <input
                        type="text"
                        value={name}
                        placeholder="Name"
                        onChange={(e) => setName(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="text"
                        readOnly 
                        value={email}
                        placeholder="Email"
                        onChange={(e) => setEmail(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Password</label>
                      <input
                        type="text"
                        value={password}
                        placeholder="Password"
                        onChange={(e) => setPassword(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Phone</label>
                      <input
                        
                        type="text"
                        value={mobileNumber}
                        placeholder="Mobile Number"
                        onChange={(e) => setMobileNumber(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>



                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>City</label>
                      <input
                        type="text"
                        value={city}
                        placeholder="City"
                        onChange={(e) => setCity(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Address</label>

                      <textarea
                        value={address}
                        placeholder="Address"
                        onChange={(e) => setAddress(e.target.value)}
                        className="form-control"
                      >

                      </textarea>

                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Email Verified</label>
                      <div className="row">
                        <div className="col-sm-3">
                          <input type="radio" id="statusEmailVerified" name="email_verify" className=""
                            value="1"
                            checked={emailverify === '1'}
                            onChange={() =>  setEmailverify('1')}

                          /> <label htmlFor="statusEmailVerified">Verified</label>
                        </div>
                        <div className="col-sm-3">
                          <input type="radio" id="statusEmailunVerified" name="email_verify" className="custom-control-inpu"
                            value="0"
                            checked={emailverify === '0'}
                            onChange={() => setEmailverify('0')}
                          /> <label htmlFor="statusEmailunVerified">Unverified</label>
                        </div>
                      </div>
                      </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Mobile Number  Verified</label>
                      <div className="row">
                        <div className="col-sm-3">
                          <input type="radio" id="statusMobileVerified" name="phone_verify" className=""
                            value="1"
                            checked={is_mobile_verified === '1'}
                            onChange={() =>  setis_mobile_verified('1')}

                          /> <label htmlFor="statusMobileVerified">Verified</label>
                        </div>
                        <div className="col-sm-3">
                          <input type="radio" id="statusMobileunVerified" name="phone_verify" className="custom-control-inpu"
                            value="0"
                            checked={is_mobile_verified === '0'}
                            onChange={() => setis_mobile_verified('0')}
                          /> <label htmlFor="statusMobileunVerified">Unverified</label>
                        </div>
                      </div>
                      </div>
                  </div>


                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Account Verified</label>
                      <div className="row">
                        <div className="col-sm-3">
                          <input type="radio" id="accountverified" name="account_verify" className=""
                            value="1"
                            checked={is_approved === '1'}
                            onChange={() =>  setis_approved('1')}

                          /> <label htmlFor="accountverified">Verified</label>
                        </div>
                        <div className="col-sm-3">
                          <input type="radio" id="accountunverified" name="account_verify" className="custom-control-inpu"
                            value="0"
                            checked={is_approved === '0'}
                            onChange={() => setis_approved('0')}
                          /> <label htmlFor="accountunverified">Unverified</label>
                        </div>
                      </div>
                      </div>
                  </div>



                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Status</label>
                      <div className="row">
                        <div className="col-sm-3">
                          <input type="radio" id="statusActive" name="status" className=""
                            value="1"
                            checked={status === '1'}
                            onChange={actvieStatus}

                          /> <label htmlFor="statusActive">Active</label>
                        </div>
                        <div className="col-sm-3">
                          <input type="radio" id="statusInactive" name="status" className="custom-control-inpu"
                            value="0"
                            checked={status === '0'}
                            onChange={inactvieStatus}
                          /> <label htmlFor="statusInactive">Inactive</label>
                        </div>
                      </div>
                      </div>
                  </div>

                  <div className="col-12">
                    <div className="card-footer text-center">
                      <button className="btn btn-primary mr-1" type="submit" disabled={disabled}>{disabled == false ? 'Submit' : 'Submiting...'}</button>

                    </div>
                  </div>
                </div>
              </form>
              : '' }
            </div>
          </div>
        </div>
      </div>
    </>

  );
}

export default Useredit;
